import { Grid, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import _keyBy from 'lodash/keyBy';
import _pick from 'lodash/pick';
import moment from 'moment';

const ToolTip = ({ title, tooltiptext }) => (
  <Tooltip title={tooltiptext} arrow>
    <Typography variant="body1" style={{ fontWeight: '600' }}>
      {title}
    </Typography>
  </Tooltip>
);

const PxDealers = [
  {
    accessorKey: 'rowId',
    header: 'ID',
    minSize: 40,
    maxSize: 40,
    size: 40,
    Cell: ({ cell }) => cell.row.index + 1,
  },
  {
    accessorKey: 'employeeName',
    header: 'Employee Name',
    minSize: 170,
    maxSize: 200,
    size: 170,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },

  {
    accessorKey: 'departmentRoleTitle',
    header: 'Role',
    minSize: 170,
    maxSize: 300,
    size: 110,
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()}</Typography>,
  },
  {
    accessorKey: 'luCompleted',
    header: <ToolTip title="LU" tooltiptext="Learning Units completed" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'learningDays',
    header: <ToolTip title="AD" tooltiptext="Active Days" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'rank',
    header: <ToolTip title="LR" tooltiptext="Leaderboard Rank" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'employeeStreakNumber',
    header: <ToolTip title="CS" tooltiptext="Current Streak" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: '',
    header: <ToolTip title="SC" tooltiptext="Stars Collected" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'employeeDevices',
    header: 'App Version ',
    minSize: 60,
    maxSize: 60,
    size: 60,
    Cell: ({ cell }) => {
      const devices = cell.row.original.employeeDevices;
      const latestV = devices?.length > 0 ? devices[0]?.appVersion : null;
      const type = devices?.length > 0 ? devices[0]?.appType : null;
      let deviceType = null;
      if (type === 'android') {
        deviceType = 'Android';
      } else if (type === 'ios') {
        deviceType = 'iOS';
      }

      if (latestV) {
        return (
          <Grid>
            <Typography>{latestV}</Typography>
            <Typography style={{ color: '#344054', fontSize: '12px' }}>{deviceType}</Typography>
          </Grid>
        );
      }

      return <Typography>--</Typography>;
    },
  },
  {
    accessorKey: 'lasteSeenTime',
    header: 'Last Seen',
    minSize: 60,
    maxSize: 60,
    size: 60,
    Cell: ({ cell }) => {
      const lastSeenTime = cell.row.original.lasteSeenTime;

      if (lastSeenTime) {
        return <Typography noWrap>{lastSeenTime}</Typography>;
      }
      return <Typography>--</Typography>;
    },
  },
  {
    accessorKey: 'employeeStreakNumber',
    header: <ToolTip title="CS" tooltiptext="Current Streak" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'journeyName',
    header: 'Journey Name',
    minSize: 120,
    maxSize: 120,
    size: 120,
    Cell: ({ cell }) => {
      const name = cell.row.original?.journey?.title || '--';
      return <Typography>{name}</Typography>;
    },
  },
  {
    accessorKey: 'journryTitle',
    header: 'Journey Name',
    minSize: 1300,
    maxSize: 130,
    size: 130,
  },
  {
    accessorKey: 'topicTitle',
    header: 'Topic Name',
    minSize: 1300,
    maxSize: 130,
    size: 130,
  },
  {
    accessorKey: 'colcTitle',
    header: 'Collection Name',
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'assignedBy',
    header: 'Assigned By',
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'startDate',
    header: 'Start Date',
    minSize: 60,
    maxSize: 60,
    size: 60,
    Cell: ({ cell }) => {
      const date = cell.row.original.startDate;
      const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '--';
      return <Typography variant="p">{formattedDate}</Typography>;
    },
  },
  {
    accessorKey: 'endDate',
    header: 'Due Date',
    minSize: 60,
    maxSize: 60,
    size: 60,
    Cell: ({ cell }) => {
      const date = cell.row.original.endDate;
      const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '--';
      return <Typography variant="p">{formattedDate}</Typography>;
    },
  },

  {
    accessorKey: 'completedEmployees',
    header: <ToolTip title="Comp." tooltiptext="Completed" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'inProgressEmployees',
    header: <ToolTip title="IP" tooltiptext="In Progress" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'notStarted',
    header: <ToolTip title="NS" tooltiptext="Not Started" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'completedUsers',
    header: <ToolTip title="Comp." tooltiptext="Completed" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'inProgressUsers',
    header: <ToolTip title="IP" tooltiptext="In Progress" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'notStartedUsers',
    header: <ToolTip title="NS" tooltiptext="Not Started" />,
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'totalUsers',
    header: 'Users',
    minSize: 60,
    maxSize: 60,
    size: 60,
  },
  {
    accessorKey: 'dueDate',
    header: 'Due Date',
    minSize: 60,
    maxSize: 60,
    size: 60,
    Cell: ({ cell }) => {
      const dueDate = cell.row.original?.journey?.dueDate;
      const formattedDate = dueDate ? moment(dueDate).format('YYYY-MM-DD') : '--';
      return <Typography>{formattedDate}</Typography>;
    },
  },
];

const ALL_EMP = [
  'rowId',
  'employeeName',
  'departmentRoleTitle',
  'luCompleted',
  'rank',
  'learningDays',
  'employeeStreakNumber',
  'employeeDevices',
];

const INACTIVE_EMP = ['rowId', 'employeeName', 'departmentRoleTitle', 'lasteSeenTime', 'employeeDevices'];

const Managers = [
  'rowId',
  'employeeName',
  'departmentRoleTitle',
  'luCompleted',
  'journeyAssigned',
  'learningDays',
  'rank',
  'employeeStreakNumber',
  'employeeDevices',
];

const ToMJ = [
  'rowId',
  'journryTitle',
  'topicTitle',
  'startDate',
  'endDate',
  'completedEmployees',
  'inProgressEmployees',
  'notStarted',
];

const DealerAssigned = [
  'rowId',
  'journeyName',
  'assignedBy',
  'startDate',
  'endDate',
  'completedUsers',
  'inProgressUsers',
  'notStartedUsers',
];

const OEM_J = ['rowId', 'journeyName', 'dueDate', 'inProgressUsers', 'notStartedUsers', 'totalUsers'];

const PxDealerColumns = (tabId, empType, setEmpHash, Jtype) => {
  let selectedTab = ALL_EMP;

  if (tabId === 0 && empType === 0) {
    selectedTab = ALL_EMP;
  }

  if (tabId === 0 && empType === 1) {
    selectedTab = INACTIVE_EMP;
  }
  if (tabId === 1) {
    selectedTab = Managers;
  }
  if (tabId === 2 && Jtype === 0) {
    selectedTab = ToMJ;
  }
  if (tabId === 2 && Jtype === 1) {
    selectedTab = DealerAssigned;
  }
  if (tabId === 2 && Jtype === 2) {
    selectedTab = OEM_J;
  }

  const pxTableMap = _keyBy(PxDealers, 'accessorKey');
  const filteredColumns = _pick(pxTableMap, selectedTab);

  if (filteredColumns.employeeName) {
    filteredColumns.employeeName.Cell = ({ cell }) => {
      const handleClick = () => {
        setEmpHash(cell.row.original.hash);
      };
      return (
        <Typography onClick={handleClick} style={{ color: '#622FEE', cursor: 'pointer' }}>
          {cell.getValue()}
        </Typography>
      );
    };
  }

  return Object.values(filteredColumns);
};

export default PxDealerColumns;
